import { useAtom } from 'jotai';
import { isDrawerOpenAtom } from './AppDrawerOpenAtom';

export const useConfigAppDrawerOpen = () => {
    return useAtom(isDrawerOpenAtom);
};
